import classes from './FiveStarRating.module.scss';

export default function FiveStarRating({ rating }) {
    return (
        <div className={classes.mRatingWidget}>
            <div className={`${classes.aRating} rating-${rating}`} />
            <style global jsx>{`
                .rating-0 {
                    width: 0px;
                    right: auto;
                }
                .rating-1 {
                    width: 30px;
                    right: auto;
                }
                .rating-2 {
                    width: 60px;
                    right: auto;
                }
                .rating-3 {
                    width: 90px;
                    right: auto;
                }
                .rating-4 {
                    width: 120px;
                    right: auto;
                }
                .rating-5 {
                    width: 150px;
                    right: auto;
                }
            `}</style>
        </div>
    );
}
